import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import ClienteLayout from '../../components/ClienteLayout'
import TrustBadge from '../../components/TrustBadge'
import { useAuth } from '../../lib/AuthContext'
import { supabase } from '../../lib/supabase'
import { getMisSuscripciones, getMisPedidos } from '../../lib/portalClienteApi'

const WA_NUMERO = '59898610001'

export default function Cuenta() {
  const { user, profile } = useAuth()
  const navigate = useNavigate()
  const [suscripciones, setSuscripciones] = useState([])
  const [pedidos, setPedidos] = useState([])
  const [cargando, setCargando] = useState(true)

  useEffect(() => { if (user?.id) cargar() }, [user?.id])

  async function cargar() {
    setCargando(true)
    const [ss, peds] = await Promise.all([
      getMisSuscripciones(user.id),
      getMisPedidos(50),
    ])
    setSuscripciones(ss)
    setPedidos(peds)
    setCargando(false)
  }

  async function handleLogout() {
    await supabase.auth.signOut()
    navigate('/login')
  }

  const direcciones = suscripciones.length
  const totalPedidos = pedidos.length
  const susc = suscripciones[0]
  const tarjeta = susc?.mp_card_brand && susc?.mp_card_last4
    ? `${susc.mp_card_brand.toUpperCase()} ···${susc.mp_card_last4}`
    : null

  const initial = (profile?.nombre || user?.email || 'U').charAt(0).toUpperCase()
  const nombreCompleto = profile?.nombre || (user?.email || '').split('@')[0]
  const telefono = profile?.phone

  return (
    <ClienteLayout title="Mi Cuenta">
      <div className="cu-wrap">
        <div className="cu-headline">
          <h1>Mi Cuenta</h1>
          <p>Datos personales, direcciones, pago y soporte.</p>
        </div>

        <div className="cu-grid">
          {/* Perfil hero */}
          <div className="cu-perfil">
            <div className="cu-avatar">{initial}</div>
            <div className="cu-perfil-info">
              <div className="cu-nombre">{nombreCompleto}</div>
              <div className="cu-email">{user?.email}</div>
              {telefono && <div className="cu-tel">{telefono}</div>}
            </div>
            <Link to="/cliente/perfil" className="cu-edit-btn">Editar perfil</Link>
          </div>

          {/* Datos */}
          <div className="cu-col">
            <h2 className="cu-section">Datos</h2>
            <div className="cu-list">
              <Link to="/cliente/mi-plan" className="cu-row">
                <div className="cu-row-icon">📍</div>
                <div className="cu-row-label">Mis direcciones</div>
                <div className="cu-row-meta">{direcciones} dirección{direcciones === 1 ? '' : 'es'}</div>
                <div className="cu-row-arrow">›</div>
              </Link>
              <Link to="/cliente/pedidos" className="cu-row">
                <div className="cu-row-icon">📜</div>
                <div className="cu-row-label">Historial de pedidos</div>
                <div className="cu-row-meta">{totalPedidos} pedido{totalPedidos === 1 ? '' : 's'}</div>
                <div className="cu-row-arrow">›</div>
              </Link>
              <Link to={susc ? `/cliente/cargar-tarjeta/${susc.id}` : '#'} className="cu-row">
                <div className="cu-row-icon">💳</div>
                <div className="cu-row-label">Método de pago</div>
                <div className="cu-row-meta">{tarjeta || 'Sin tarjeta cargada'}</div>
                <div className="cu-row-arrow">›</div>
              </Link>
              <button className="cu-row" onClick={() => alert('Próximamente: descargar todas tus facturas')}>
                <div className="cu-row-icon">🧾</div>
                <div className="cu-row-label">Mis facturas</div>
                <div className="cu-row-meta">Próximamente</div>
                <div className="cu-row-arrow">›</div>
              </button>
              <button className="cu-row" onClick={() => alert('Próximamente: gestionar notificaciones')}>
                <div className="cu-row-icon">🔔</div>
                <div className="cu-row-label">Notificaciones</div>
                <div className="cu-row-meta">Email · WhatsApp</div>
                <div className="cu-row-arrow">›</div>
              </button>
            </div>
            <div style={{ marginTop: 14 }}>
              <TrustBadge variant="default" />
            </div>
          </div>

          {/* Comunidad y ayuda */}
          <div className="cu-col">
            <h2 className="cu-section">Comunidad y ayuda</h2>
            <Link to="/cliente/vecinos" className="cu-vecinos">
              <div className="cu-vecinos-h">👥 Vecinos en tu cuadra</div>
              <div className="cu-vecinos-sub">Si llegan a 10, todos ganan <b>5% de descuento</b> permanente.</div>
              <div className="cu-vecinos-cta">Ver y compartir →</div>
            </Link>
            <a className="cu-soporte"
               href={`https://wa.me/${WA_NUMERO}?text=${encodeURIComponent('Hola Limpack, necesito ayuda con mi cuenta.')}`}
               target="_blank" rel="noreferrer">
              <div className="cu-soporte-icon">💬</div>
              <div className="cu-soporte-info">
                <div className="cu-soporte-titulo">Hablar con Limpack</div>
                <div className="cu-soporte-sub">WhatsApp · Lun a Vie 9–18hs</div>
              </div>
              <div className="cu-soporte-arrow">›</div>
            </a>
            <button className="cu-logout" onClick={handleLogout}>Salir de mi cuenta</button>
          </div>
        </div>
      </div>

      <style>{`
        .cu-wrap { max-width: 1100px; margin: 0 auto; padding: 16px 16px 32px }
        .cu-headline h1 { font-size: 26px; font-weight: 900; color: var(--cl-navy); letter-spacing: -.02em }
        .cu-headline p { font-size: 14px; color: var(--cl-muted); margin-top: 4px; line-height: 1.5 }

        .cu-grid { display: grid; grid-template-columns: 1fr; gap: 18px; margin-top: 18px }

        .cu-perfil {
          grid-column: 1 / -1;
          background: linear-gradient(135deg, var(--cl-navy), var(--cl-navy-2));
          color: #fff; padding: 20px; border-radius: 18px;
          display: flex; align-items: center; gap: 14px; flex-wrap: wrap;
        }
        .cu-avatar {
          width: 56px; height: 56px; border-radius: 50%;
          background: linear-gradient(135deg, var(--cl-teal), var(--cl-blue));
          display: flex; align-items: center; justify-content: center;
          font-size: 22px; font-weight: 900;
        }
        .cu-perfil-info { flex: 1; min-width: 0 }
        .cu-nombre { font-size: 17px; font-weight: 800 }
        .cu-email { font-size: 12px; opacity: .75; margin-top: 2px; word-break: break-all }
        .cu-tel { font-size: 11px; opacity: .65; margin-top: 1px }
        .cu-edit-btn {
          background: rgba(255,255,255,.12); border: 1px solid rgba(255,255,255,.2);
          color: #fff; padding: 8px 14px; border-radius: 999px;
          font-size: 12px; font-weight: 700; text-decoration: none;
        }
        .cu-edit-btn:hover { background: rgba(255,255,255,.2) }

        .cu-section { font-size: 14px; font-weight: 900; color: var(--cl-navy); margin: 0 0 12px; letter-spacing: -.01em }

        .cu-list { background: var(--cl-card); border: 1px solid var(--cl-line); border-radius: 14px; overflow: hidden }
        .cu-row {
          display: flex; align-items: center; gap: 14px;
          padding: 14px 16px; border-bottom: 1px solid var(--cl-line2);
          cursor: pointer; transition: background .12s;
          background: none; border-left: 0; border-right: 0; border-top: 0;
          text-decoration: none; color: var(--cl-navy); width: 100%;
          font-family: inherit; text-align: left;
        }
        .cu-row:hover { background: var(--cl-line2) }
        .cu-row:last-child { border-bottom: 0 }
        .cu-row-icon { font-size: 18px; width: 22px; text-align: center; flex-shrink: 0 }
        .cu-row-label { flex: 1; font-size: 13.5px; font-weight: 700 }
        .cu-row-meta { font-size: 12px; color: var(--cl-muted); flex-shrink: 0 }
        .cu-row-arrow { color: var(--cl-muted2); font-size: 16px; flex-shrink: 0 }

        .cu-vecinos {
          padding: 18px; border-radius: 14px;
          background: linear-gradient(135deg, #ecfdf5, #d1fae5);
          border: 1px solid #86efac; text-decoration: none;
          margin-bottom: 12px; display: block;
          transition: transform .15s;
        }
        .cu-vecinos:hover { transform: translateY(-1px) }
        .cu-vecinos-h { font-size: 14px; font-weight: 800; color: #065f46 }
        .cu-vecinos-sub { font-size: 12px; color: #047857; margin-top: 6px; line-height: 1.5 }
        .cu-vecinos-cta { font-size: 12px; font-weight: 800; color: #065f46; margin-top: 10px; letter-spacing: .04em }

        .cu-soporte {
          padding: 14px; border-radius: 14px;
          background: linear-gradient(135deg, #25d366, #128c7e);
          color: #fff; display: flex; align-items: center; gap: 12px;
          text-decoration: none; margin-bottom: 12px;
          transition: transform .15s;
        }
        .cu-soporte:hover { transform: translateY(-1px) }
        .cu-soporte-icon { font-size: 22px }
        .cu-soporte-info { flex: 1 }
        .cu-soporte-titulo { font-size: 13px; font-weight: 800 }
        .cu-soporte-sub { font-size: 11px; opacity: .9; margin-top: 1px }
        .cu-soporte-arrow { font-size: 16px; opacity: .8 }

        .cu-logout {
          width: 100%; padding: 12px;
          background: var(--cl-card); border: 1px solid var(--cl-line);
          border-radius: 12px; text-align: center;
          font-size: 13px; font-weight: 800; color: #b91c1c;
          cursor: pointer; font-family: inherit;
          transition: border-color .15s, background .15s;
        }
        .cu-logout:hover { border-color: #b91c1c; background: #fee2e2 }

        @media (min-width: 900px) {
          .cu-wrap { padding: 36px 44px }
          .cu-headline h1 { font-size: 32px }
          .cu-grid { grid-template-columns: 1fr 1fr; gap: 24px }
          .cu-perfil { padding: 24px 26px }
          .cu-avatar { width: 64px; height: 64px; font-size: 26px }
          .cu-nombre { font-size: 19px }
          .cu-email { font-size: 13px }
          .cu-section { font-size: 16px; margin-bottom: 14px }
          .cu-row { padding: 16px 20px }
          .cu-row-label { font-size: 14px }
        }
      `}</style>
    </ClienteLayout>
  )
}
